import { useCallback } from 'react'
import { DefaultNoteModel } from '@user/components/Settings/Notes/typings'
import { useAppDispatch } from '@user/store/hooks'
import { saveNoteSettings } from '@user/store/notes/api'

export function useHandlers() {
  const dispatch = useAppDispatch()

  const onSubmit = useCallback(
    async (model: DefaultNoteModel) => {
      await dispatch(saveNoteSettings(model))
    },
    [dispatch],
  )

  return {
    onSubmit,
  }
}
